import { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import db from "../../../backend/DBFiresbase";
import getIDDoc from "../../../helpers/getIDDoc";
import styles from './Form.module.css';


export const BtnDeleteGasto = ( { proyecto, documento, numDocumento='numDocumento' } ) => {

  const [ idProyecto, setIdProyecto ] = useState("");

  const deleteData = async () => {
    const proyectoRef = doc(db, "proyectos", idProyecto);
    const docRef = await  getDoc(proyectoRef);
    const gastoIndex = docRef.data().gastos.findIndex(el => el[numDocumento] === documento );
    if(gastoIndex !== -1){
      const nuevosGastosArray = [...docRef.data().gastos];
      nuevosGastosArray.splice(gastoIndex, 1);
      updateDoc(proyectoRef, { gastos: nuevosGastosArray });
    }
  }

  const handleClick = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success m-2',
        cancelButton: 'btn btn-danger m-2'
      },
      buttonsStyling: false
    })
    
    swalWithBootstrapButtons.fire({
      title: '¿Desea eliminar el registro?',
      text: "Si elimina, ya no lo podrá recuperar",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {

        deleteData();

        swalWithBootstrapButtons.fire(
          '¡Eliminado!',
          'Registro fue eliminado con éxito',
          'success'
        )
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          '¡Cancelado!',
          'El registro se mantiene',
          'error'
        )
      }
    })
  }

  useEffect(() => {
    getIDDoc("proyectos", proyecto, setIdProyecto)
  }, [])

  return (<>
    <button className={`btn py-0 ${styles.btnEliminar}`} onClick={ handleClick }>
      <i className="bi bi-trash3"></i>
    </button>
  </>)
}
